module.exports = __webpack_public_path__ + "media/images/illustration_14-51e2cf9bd1628657d78c135ecd42ac31.png";